<div class="confirmation-modal-container">
  <div class="custom-modal-header">
    <div class="title">{{ title | translate }}</div>
    <div class="close-button" (click)="modalService.dismiss('Cross click')"><i class="bi bi-x x-icon"></i></div>
  </div>
  <div class="custom-modal-content">
    {{ message | translate }}
  </div>
  <div class="custom-modal-footer">
    <div class="submit-actions">
      <button class="btn secondary-button" (click)="confirm(false)">{{ notConfirmActionLabel | translate }}</button>
      <button class="btn primary-button" (click)="confirm(true)">{{ confirmActionLabel | translate }}</button>
    </div>
  </div>
</div>
